
import axios from "axios";
import { store } from '../store';
import {router} from "../helpers";
import {i18n} from "../i18n";

export const stripeService = {
    charge,
    createIntent,
    setPaymentStatus,
    createSubscription,
    subscriptionIntent,
    confirmSubscription,
    updateCardIntent,
    updateCard
};

function charge(amount, token, description, email, basketProducts) {
    let data = {
        amount: amount,
        token: token,
        description: description,
        email: email,
        products: basketProducts
    }

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/stripe/charge', data)
        .then(response => {

            // login successful if there's a jwt token in the response
            if (response.status === 200 && response.data) {
                store.dispatch('alert/success', 'Payment Success', { root: true }).then();
                store.dispatch('basket/clear').then();
            }

            return response.data;
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                store.dispatch('alert/error', 'Payment Failed', { root: true }).then();

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function createIntent(amount, brand, discount, basketProducts, delivery, voucher) {

    let currency = 'gbp'
    if (brand === 'neotag') {
        currency = 'eur'
    }

    let data = {
        amount: amount,
        currency: currency,
        brand: brand,
        discount: discount,
        products: basketProducts,
        delivery,
        voucher: voucher
    }

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/stripe/create-intent', data)
        .then(response => {
            return response.data;
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else if(error.response.status === 403) {
                    store.dispatch('alert/error', error.response.data.error, { root: true }).then();
                }

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function setPaymentStatus(paymentIntent) {
    let data = {
        id: paymentIntent.id,
        status: paymentIntent.status
    }

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/stripe/update-status', data)
        .then(response => {
            return response.data;
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function createSubscription(brand, couponId) {

    let data = {
        brand: brand,
        coupon_id: couponId
    }

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/stripe/create-subscription', data)
        .then(response => {
            return response.data;
        })
        .catch(function (error) {
            //
        });
}

function subscriptionIntent() {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/stripe/subscription-intent')
        .then(response => {
            return response.data;
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else if(error.response.status === 403) {
                    store.dispatch('alert/error', error.response.data.error, { root: true }).then();
                }

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function confirmSubscription(brand) {

    let data = {
        brand: brand
    }

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/stripe/confirm-subscription', data)
        .then(response => {
            return response.data;
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else if(error.response.status === 403) {
                    store.dispatch('alert/error', error.response.data.error, { root: true }).then();
                }

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function updateCardIntent() {

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/stripe/update-card-intent')
        .then(response => {
            return response.data;
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else if(error.response.status === 403) {
                    store.dispatch('alert/error', error.response.data.error, { root: true }).then();
                }

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

function updateCard(paymentMethodId) {

    let data = {
        payment_method_id: paymentMethodId
    }

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .post('/api/stripe/update-card', data)
        .then(response => {
            return response.data;
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);

                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else if(error.response.status === 403) {
                    store.dispatch('alert/error', error.response.data.error, { root: true }).then();
                }

            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The login was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}
